export const eventId = config => {
  return {
    'event:id': config.key
  };
};